export default "__VITE_ASSET__DvABOnW7__"